// Helper to parse CSV lines properly handling quoted values
export function parseCSVLine(line: string): string[] {
  const values: string[] = [];
  let currentValue = '';
  let inQuotes = false;
  
  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    
    if (char === '"') {
      inQuotes = !inQuotes;
      continue;
    }
    
    if (char === ',' && !inQuotes) {
      values.push(currentValue.trim());
      currentValue = '';
      continue;
    }
    
    currentValue += char;
  }
  
  // Add the last value
  values.push(currentValue.trim());
  
  return values;
}